import { Injectable } from '@angular/core';

/**
 * One place every handled failure passes through.
 *
 * Errors were previously swallowed into console.log calls scattered across the
 * components, which put them in the same stream as ordinary logging and left
 * nothing to hook telemetry onto. Routing them through here keeps them visible
 * as errors and gives a single place to add reporting later, without going back
 * round every call site.
 */
@Injectable({ providedIn: 'root' })
export class ErrorReportingService {

  /**
   * @param context  what was being attempted, in plain words, so a report is
   *                 readable without reading the code.
   */
  report(context: string, error: unknown): void {
    console.error(`[CVDPREVENT] ${context}`, error);
  }
}
